module.exports = __webpack_public_path__ + "static/media/logo3x.d6466752.png";